import { createContext, useContext, useState } from "react";

const UIContext = createContext(null);

export function UIProvider({ children }) {
  const [callbackOpen, setCallbackOpen] = useState(false);
  return (
    <UIContext.Provider value={{ callbackOpen, setCallbackOpen }}>
      {children}
    </UIContext.Provider>
  );
}

export function useUI() {
  return useContext(UIContext);
}
